import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useArchivesNeighborhoodsStore = defineCollectionStore({
    id: 'archives-neighborhoods',
    endpoint: '/api/archives/neighborhoods',
    dataKey: 'hoods',
    mapKey: 'hood_map',
    errorLabel: 'Fetch Archived Neighborhoods Error: ',
    fetchName: 'fetchArchivedNeighborhoods',
    extraState: () => ({
        hoods: null,
        hood_map: null,
    }),
    getters: {
        neighborhoodsData(state: any) {
            return state.hoods;
        },
        neighborhoodsMap(state: any) {
            return state.hood_map;
        },
    },
});
